// extracted by mini-css-extract-plugin
export default {"circle":"style_circle__NUJzI","left-square":"style_left-square__-mn5g","flash":"style_flash__wMgmY","right-square":"style_right-square__nypT4"};